import { Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UtilService } from 'src/app/services/util/util.service';
import { NotificationDto } from '../../dto/notification-center/notification.dto';
import { MenuService } from '../../services/menu/menu.service';
import { NotificationCenterService } from '../../services/notification-center/notification-center.service';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar-portable';
import { UserDisplayComponent } from '../user-display/user-display.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { DateAgoPipe } from 'src/app/pipes/date-ago.pipe';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    imports: [ModalDirective, PerfectScrollbarDirective, UserDisplayComponent, MatTooltip, TranslatePipe, DateAgoPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationCenterComponent implements OnInit {
  notificationCenterService = inject(NotificationCenterService);
  menuService = inject(MenuService);
  util = inject(UtilService);
  private router = inject(Router);
  private location = inject(Location);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('slideRightModal') slideRightModal: ModalDirective;
  @ViewChild('mdStickUp') mdStickUp: ModalDirective;
  loading = false;
  selectedNotification: any;

  private periodStartDate: number = null;
  private periodEndDate: number = null;

  ngOnInit(): void {
    this.countUnviewedNotifications();
  }

  countUnviewedNotifications = () => {
    this.notificationCenterService.countUnviewedNotifications().subscribe(() => {
      this.cdr.markForCheck();
    }, () => {
      this.cdr.markForCheck();
    });
  };

  show = async () => {
    this.loading = true;
    this.slideRightModal.show();

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const newMonth = (month - 2 + 12) % 12;
    const newYear = month - 2 < 0 ? year - 1 : year;
    const twoMonthsEarly = new Date(newYear, newMonth, today.getDate());

    this.periodStartDate = twoMonthsEarly.valueOf();
    this.periodEndDate = today.valueOf();

    this.listUserNotifications(false);
    if (this.notificationCenterService?.countUnseenNotifications) {
      this.notificationCenterService.countUnseenNotifications = 0;
      this.viewAllNotifications();
    }
  };

  hide = () => {
    this.slideRightModal.hide();
  };

  // Primeira página: append=false (substitui); scroll: append=true (anexa).
  listUserNotifications = (append = false) => {
    const cursor = append ? this.notificationCenterService.nextCursor : null;
    this.notificationCenterService
      .listUserNotifications(this.periodStartDate, this.periodEndDate, cursor, 20, append)
      .subscribe(() => {
        this.loading = false;
        this.cdr.markForCheck();
      }, () => {
        this.loading = false;
        this.cdr.markForCheck();
      });
  };

  // Chamado pelo scroll infinito quando o user chega perto do fim da lista.
  loadMore = () => {
    if (this.notificationCenterService.hasMore && !this.loading) {
      this.loading = true;
      this.listUserNotifications(true);
    }
  };

  // viewAll pode marcar em batches — encadeia enquanto hasMore=true.
  viewAllNotifications = () => {
    this.notificationCenterService.viewAllNotifications().subscribe((resp) => {
      if (resp?.hasMore) {
        this.viewAllNotifications();
      } else {
        this.cdr.markForCheck();
      }
    }, () => {
      this.cdr.markForCheck();
    });
  };

  goToNotificationEntity = async (notificationDto: NotificationDto) => {
    notificationDto.isRead = 1;
    notificationDto.readOn = notificationDto?.readOn ?? new Date().toISOString();

    this.notificationCenterService.readNotification(notificationDto?.createdOn).subscribe(() => {
      this.cdr.markForCheck();
    }, () => {
      this.cdr.markForCheck();
    });

    const notificationUrl = notificationDto?.url ? notificationDto.url.replace('detalhe', 'detail') : '';

    let entityUrl = notificationUrl ? notificationUrl : this.notificationCenterService.getEntityUrl(notificationDto);
    if (entityUrl && (!this.location?.path() || this.location?.path() !== entityUrl) && notificationDto.entityType != 'MESSAGE_SENDER') {
      let navigationSucceeds = await this.router.navigateByUrl(entityUrl);
      if (!navigationSucceeds || !this.location?.path()) {
        entityUrl = this.notificationCenterService.getEntityUrl(notificationDto);
        navigationSucceeds = await this.router.navigateByUrl(entityUrl);
        if (!navigationSucceeds || !this.location?.path() && notificationDto?.entityType) {
          if(notificationDto.entityType.toLowerCase() == 'workflow'){
            this.util.navWithParams({idWorkflow: notificationDto.resourceId, isStep: true}, notificationDto.entityType.toLowerCase())
          } else {
            this.router.navigateByUrl(notificationDto.entityType.toLowerCase());
          }
        }
      }
      this.hide();
    } else {
      this.selectedNotification = notificationDto;
      if (entityUrl?.indexOf('message_sender') == -1) {
        window.open(entityUrl, '_blank');
      } else {
        this.mdStickUp.show();
      }
    }
  };

  getNotification = (createdOn: string) => {
    this.notificationCenterService.getNotification(createdOn).subscribe(() => {
      this.cdr.markForCheck();
    }, () => {
      this.cdr.markForCheck();
    });
  };

}
